<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Serivces
	import { postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Stores
		//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	//Types
	import type { InputClickEvent } from 'src/types/InputClickEvent';
	//Design system components
	import { Toggle, toast } from '@Shelly/shelly-design-system';

	$: settingsStore = getDeviceSettings(id);
	export let device;

	const id = real_id(device.id);
	let settings = $settingsStore;
	let checked = $settingsStore.led_status_disable;
	let loading = false;

	const sentRequest = async (e: InputClickEvent) => {
		loading = true;
		checked = e.target.checked;
		const res = await postReq(
			`/device/settings/led_status_disable`,
			{
				id: id,
				enabled: checked ? 1 : 0,
			},
			10000,
		);

		if (res.isok) {
			settings.led_status_disable = checked;
			devices_settings.update_devices_settings(id, settings);
			toast.open({
				type: 'success',
				title: !checked
					? $format('led_light_enabled_scc_toast')
					: $format('led_light_disabled_scc_toast', {
							default: `Led status light was ${!checked ? 'enabled' : 'disabled'}.`,
						}),
			});
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
			checked = !checked;
		}
		loading = false;
	};
</script>

<Toggle size="m" disabled={loading} {checked} on:click={sentRequest} id="toggle-my9oalf">
	{$format('device_wi_fi_led_description') || 'Disable wifi status led.'}
</Toggle>
